import {request} from "@/api/request.js";
const Search={
    getHomeSNV(search){
        return request.get(
            "/home/snv/search",
            {
                search: search
            })
    },
    getHomeGene(search){
        return request.get(
            "/home/gene/search",
            {
                search: search
            })
    },
    getHomeGenonmic(search){
        return request.get(
            "/home/genonmic_region/search",
            {
                search: search
            })
    }
}
export default Search;
